module.exports = __webpack_public_path__ + "static/media/embracon.c5e56de2.webp";